
import { getMaterial } from '@/apis/ad'
import { onMounted, ref, watch, defineComponent, computed } from 'vue';
import Confirm from '@/components/confirm/confirm.vue'
import { isVideo, numberToTime } from './utils'
import VideoPoster from './videoPoster.vue'

// modelValue  type { index: 0, cards:[ { id: 1, url:'' } ], duration: 10 }
const __default__ = defineComponent({
  name: 'materialCard',
  components: { VideoPoster, Confirm},
  props: {
    modelValue: { type: Object, default: { limit: 1, duration: '00:10' } },
    period: Object,
    disabled: Boolean,
  },
  setup(props, { emit }) {

    const limit = ref(props.modelValue.limit)  // 最大选择的数量
    const dialogType = ref('settime') // settime  or  materialSelect
    const visible = ref(false)
    const duration = ref('00:10')
    const checkList = ref<any[]>([]) // 复选框列表选择的值
    const materialList = ref<any[]>([]) // 复选框列表

    const handleLimitChange = (num: number) => {
      if (props.disabled) return;
      limit.value = num
      const value = { ...props.modelValue }
      if (num > checkList.value.length) {
        materialList.value.forEach(item => item.disabled = false)
      } else {
        while (checkList.value.length - limit.value > 0) {
          checkList.value.pop()
        }
        value.cards = [...checkList.value]
      }
      value.limit = num
      emit('update:modelValue', value)

      // 判断选择列表中是否有视频,只能选择一个视频
      const video = checkList.value.find(item => isVideo(item.file_name))
      if (video) {
        const id = video.id
        materialList.value.forEach(item => {
          if (isVideo(item.file_name) && item.id !== id) {
            item.disabled = true
          }
        })
      }
    }

    const handleCardClick = () => {
      if (props.disabled) return;
      visible.value = true
      dialogType.value = 'materialSelect'
    }

    // 图片拖拽排序
    let fromIndex = 0;
    let targetIndex = 0;

    const onDragstart = (event: any, index: number) => {
      fromIndex = index;
    }
    const onDragOver = (index: number) => {
      targetIndex = index
    }
    const onDrop = () => {
      const value = { ...props.modelValue } as any
      [value.cards[fromIndex], value.cards[targetIndex]] = [value.cards[targetIndex], value.cards[fromIndex]]
      emit('update:modelValue', value)
    }

    const handleClose = () => {
      visible.value = false
    }
    const handleDialogConfirm = () => {
      // 处理时间
      const value = { ...props.modelValue }
      if (dialogType.value === 'settime') {
        value.duration = duration.value
      }
      // 处理素材列表
      if (dialogType.value === 'materialSelect') {
        value.cards = [...checkList.value]
        // 判断是否有选择视频，如果有获取视频的时长
        const video = checkList.value.filter(item => item.type === 'video')
        if (video.length > 0) {
          const audio = new Audio(video[0].url)
          audio.addEventListener("loadedmetadata", (e) => {
            value.duration = numberToTime(Math.floor(audio.duration));
            visible.value = false
            emit('update:modelValue', value)
          });
          // 处理录像无法加载的情况
          audio.addEventListener("error", (e) => {
            value.duration = '00:10'
            visible.value = false
            emit('update:modelValue', value)
          }, false);
          return
        }else{
          if(value.duration === '00:00'){
            value.duration = '00:10'
          }
        }
      }
      visible.value = false
      emit('update:modelValue', value)
    }

    const handleDeleteScreen = () => {
      if (props.period) {
        const index = props.period.material.findIndex((item: any) => item.index === props.modelValue.index)
        props.period.material.splice(index, 1)
      }
    }
    
    const showEdit = computed(()=>{
      if(props.disabled) return false
      if(props.modelValue.cards.length === 0) return false 
      const hasVideo = props.modelValue.cards.find((item:any) => isVideo(item.file_name))
      return hasVideo ? false : true
    })

    watch(() => props.modelValue.cards, (newValue, oldvalue) => {
      if (newValue !== oldvalue) {
        limit.value = props.modelValue.limit
        const result: any[] = []
        props.modelValue.cards.forEach((item: any) => {
          materialList.value.forEach((i: any) => {
            if (item.id === i.id) {
              result.push(i)
            }
          })
        })
        checkList.value = result
      }
    })

    watch(() => checkList.value, (cur, pre) => {
      const length = cur.length
      if (length < limit.value) {
        materialList.value.forEach(item => item.disabled = false)

        // 判断选择列表中是否有视频,只能选择一个视频
        const video = cur.find(item => isVideo(item.file_name))
        if (video) {
          const id = video.id
          materialList.value.forEach(item => {
            if (isVideo(item.file_name) && item.id !== id) {
              item.disabled = true
            }
          })
        }

      } else {
        materialList.value.forEach(item => {
          const index = cur.findIndex(i => i.id === item.id)
          if (index === -1) {
            item.disabled = true
          } else {
            item.disabled = false
          }
        })
      }
    }, { immediate: true })

    const showCursor = props.disabled ? 'auto' : 'pointer'

    onMounted(() => {
      if (props.disabled) return;
      getMaterial({ limit: false, type: 1 }).then((res: any) => {
        if (res.code === 200) {
          materialList.value = res.data.list || []
        }
      })
    })
    return {
      limit,
      dialogType,
      visible,
      duration,
      checkList,
      materialList,
      handleLimitChange,
      handleCardClick,
      onDragstart,
      onDragOver,
      onDrop,
      handleClose,
      handleDialogConfirm,
      handleDeleteScreen,
      isVideo,
      showEdit,
      showCursor
    }
  }
})



import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "d9e14118-showCursor": (_ctx.showCursor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__